/** Allowed file extensions for case-checking document upload (matches API allowlist). */
export const CASE_DOCUMENT_ACCEPT =
  ".pdf,.docx,.doc,.txt,.xlsx,.xls,.pptx,.ppt,.jpg,.jpeg,.png,.gif,.csv,.json,.md,.markdown,.msg,.xlsm,.webp,.htm,.html,.rtf,.odt,.odp,.eml,.xml";
